'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var GemaireAppIcon = function GemaireAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512"
  }), React__default["default"].createElement("g", {
    id: "gemaire_app_icon",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, React__default["default"].createElement("g", {
    transform: "translate(-560.000000, -560.000000)",
    id: "gemaire_logo"
  }, React__default["default"].createElement("g", {
    transform: "translate(560.000000, 560.000000)"
  }, React__default["default"].createElement("rect", {
    id: "background",
    fill: "#FFFFFF",
    x: "0",
    y: "0",
    width: "512",
    height: "512"
  }), React__default["default"].createElement("g", {
    transform: "translate(64.000000, 64.000000)"
  }, React__default["default"].createElement("rect", {
    id: "background",
    fill: "#0080DE",
    x: "0",
    y: "0",
    width: "384",
    height: "384"
  }), React__default["default"].createElement("g", {
    transform: "translate(32.000000, 166.000000)",
    fill: "#FFFFFF"
  }, React__default["default"].createElement("path", {
    d: "M0,25.4167456 C0,9.87086915 11.8527089,-0.000265174864 26.2986145,-0.000265174864 C36.5954054,-0.000265174864 43.0403992,5.15738593 46.7455374,10.9766483 L38.0033312,15.6914574 C35.7807817,12.2295996 31.5583374,9.28218095 26.2986145,9.28218095 C17.3350868,9.28218095 10.8154302,16.1342994 10.8154302,25.4167456 C10.8154302,34.6991917 17.3350868,41.5499843 26.2986145,41.5499843 C30.669051,41.5499843 34.8181657,39.6354218 36.8180604,37.7924565 L36.8180604,31.8989451 L23.7800806,31.8989451 L23.7800806,22.763671 L47.3375062,22.763671 L47.3375062,41.6242333 C42.3004382,47.2234005 35.2621423,50.9066794 26.2986145,50.9066794 C11.8527089,50.9066794 0,40.8870471 0,25.4167456",
    id: "Fill-1"
  }), React__default["default"].createElement("polygon", {
    id: "Fill-2",
    points: "56.4540926 49.9487352 56.4540926 0.810506972 91.4215837 0.810506972 91.4215837 10.0187041 66.9748716 10.0187041 66.9748716 20.4069294 90.9029444 20.4069294 90.9029444 29.6151266 66.9748716 29.6151266 66.9748716 40.7392122 91.4215837 40.7392122 91.4215837 49.9487352"
  }), React__default["default"].createElement("polygon", {
    id: "Fill-3",
    points: "143.355781 49.9487352 143.355781 15.5436224 129.429848 49.9487352 124.835423 49.9487352 110.908157 15.5436224 110.908157 49.9487352 100.388711 49.9487352 100.388711 0.810506972 115.130601 0.810506972 127.132636 30.4994848 139.133337 0.810506972 153.94989 0.810506972 153.94989 49.9487352"
  }), React__default["default"].createElement("g", {
    id: "Fill-4",
    transform: "translate(156.250968, 0.787967)"
  }, React__default["default"].createElement("polygon", {
    id: "Fill-23",
    points: "48.385451 29.5205918 47.422835 26.9470697 20.7562399 27.1247369 28.0878536 7.7086333 40.9018452 9.50254126 39.7539057 6.43446808 28.5531624 6.47954781 30.3157362 1.80981845 38.5566354 3.0773543 37.2407048 1.0658141e-14 18.552356 1.0658141e-14 18.6630168 0.0172363662 18.552356 0.0172363662 -2.84217094e-14 49.1475093 12.4406779 49.1475093 20.4815877 27.8499901"
  }), React__default["default"].createElement("polygon", {
    id: "Fill-22",
    points: "43.3699818 16.1083123 42.3127042 13.2775706 26.5348688 13.4101581"
  }), React__default["default"].createElement("polygon", {
    id: "Fill-21",
    points: "45.8594507 22.763671 44.8701695 20.1185518 29.1083332 20.3055001"
  }), React__default["default"].createElement("polygon", {
    id: "Fill-26",
    points: "49.9829668 33.7960061 29.8506941 34.0943278 50.8469213 36.107005"
  }), React__default["default"].createElement("polygon", {
    id: "Fill-25",
    points: "52.5413653 40.6364569 32.4237585 40.9891395 53.3346569 42.7578558"
  }), React__default["default"].createElement("polygon", {
    id: "Fill-24",
    points: "55.0933642 47.3797211 34.2704612 47.8424512 55.7919941 49.1683256"
  })), React__default["default"].createElement("polygon", {
    id: "Fill-5",
    points: "215.597975 49.94847 226.117421 49.94847 226.117421 0.810241798 215.597975 0.810241798"
  }), React__default["default"].createElement("path", {
    d: "M265.603207,16.6496668 C265.603207,12.5235459 262.416709,10.0189693 258.195598,10.0189693 L247.157513,10.0189693 L247.157513,23.2790384 L258.195598,23.2790384 C262.416709,23.2790384 265.603207,20.7744618 265.603207,16.6496668 L265.603207,16.6496668 Z M264.567262,49.9490004 L254.861107,32.4885614 L247.157513,32.4885614 L247.157513,49.9490004 L236.638067,49.9490004 L236.638067,0.810772147 L259.751516,0.810772147 C270.048307,0.810772147 276.345308,7.51439271 276.345308,16.6496668 C276.345308,25.3434247 270.86293,29.9839848 265.528545,31.2356102 L276.641293,49.9490004 L264.567262,49.9490004 Z",
    id: "Fill-6"
  }), React__default["default"].createElement("polygon", {
    id: "Fill-7",
    points: "285.017518 49.9487352 285.017518 0.810506972 319.983676 0.810506972 319.983676 10.0187041 295.536964 10.0187041 295.536964 20.4069294 319.465037 20.4069294 319.465037 29.6151266 295.536964 29.6151266 295.536964 40.7392122 319.983676 40.7392122 319.983676 49.9487352"
  })))))));
};

var GemaireAppIcon$1 = iconStyles()(GemaireAppIcon);

module.exports = GemaireAppIcon$1;
